import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { marked } from 'marked';

import { Rights } from '@shared/enums/rights.enum';
import { Crossfilter } from '@report/shared/services/crossfilter.service';
import { BehaviorSubject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'executive-summary-card',
  templateUrl: './executive-summary-card.component.html',
  styleUrls: ['./executive-summary-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExecutiveSummaryCard implements OnInit {
  readonly Rights = Rights;

  public isMetadataVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public dataService: Crossfilter = this.cf;

  constructor(
    private cf: Crossfilter,
    @Optional() @Inject(MAT_DIALOG_DATA) readonly data: any,
  ) {}

  ngOnInit() {
    this.dataService = this.data?.dataService || this.cf;
    this.dataService.initExecutiveSummary();
  }

  public getContent() {
    const summary = this.dataService.getExecutiveSummary();
    const content = summary?.content || {};
    const error = content?.error;

    return Object.keys(content).length && !error
      ? (content.abstract || '') +
          '\n\n' +
          (content.methodologies || '') +
          '\n\n' +
          (content.keyFindings || '') +
          '\n\n' +
          (content.recommendations || '') +
          '\n\n' +
          (content.conclusion || '')
      : error || '';
  }

  public getMetadata(): { [key: string]: string | Date | number } {
    const summary = this.dataService.getExecutiveSummary();

    return {
      time: (summary?.time && new Date(summary?.time)) || null,
      userProfile: summary?.userProfile,
      companyProfile: summary?.companyProfile,
      filters: summary?.filters,
      respondents: summary?.respondents,
      themes: summary?.themes,
      mergedSurveys: summary?.mergedSurveys,
    };
  }

  public parseMarkdownToHtml(markdown: string): string {
    const parsed = marked.parse(markdown) as string;
    return parsed
      .replace(/<p/g, '<p class="zef-text-p2"')
      .replace(/<h3/g, '<h3 class="zef-text-h4"')
      .replace(/<h2/g, '<h2 class="zef-text-h3"')
      .replace(/<h1/g, '<h1 class="zef-text-h2"')
      .replace(/<li/g, '<li class="zef-text-p2"')
      .replace(/<table/g, '<table class="zef-text-p2"');
  }
}
